<template>
	<v-dialog :model-value="modelValue" @update:model-value="handleClose" width="800" persistent>
		<v-card>
			<v-card-title>{{ title }}</v-card-title>

			<v-card-text class="pa-8">
				<span class="text-body-1">{{ $t('add_comment') }}</span>
				<v-textarea v-model="comment" rows="1" variant="underlined" color="primary" auto-grow></v-textarea>
			</v-card-text>

			<v-card-actions class="pb-3 px-6">
				<v-spacer></v-spacer>
				<v-btn variant="text" color="primary" @click="handleClose(false)">
					{{ $t('action_cancel') }}
				</v-btn>

				<v-btn v-if="showDeleteButton" color="error" variant="elevated" @click="deleteWithComment">
					{{ $t('action_delete') }}
				</v-btn>

				<v-btn v-else color="primary" variant="elevated" @click="submitComment">
					{{ $t('action_save') }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	title: {
		type: String,
		required: true,
	},
	showDeleteButton: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(['update:modelValue', 'submit', 'delete', 'update']);

const comment = ref('');

watch(
	() => props.modelValue,
	(newVal) => {
		if (newVal) comment.value = '';
	}
);

const handleClose = (val = false) => {
	comment.value = '';
	emit('update:modelValue', val);
	emit('update', val);
};

const submitComment = () => {
	emit('submit', comment.value.trim());
	comment.value = '';
};

const deleteWithComment = () => {
	emit('delete', comment.value);
	comment.value = '';
};
</script>